export const CONTACT_URL = "https://wsafeai.com/contact";
export const PRICING_URL = "https://worksafeagent.com/pricing";
export const SIGNIN_URL = "https://wsafe.si";

const BRAND = "https://wsafeai.github.io/wsafeai-procore-prototype/brand/products";

export const NAV = [
  { label: "WSafe AI", href: "https://wsafeai.com" },
  { label: "HazardLoop", href: "https://hazardloop.com" },
  { label: "InductIQ", href: "https://inductiq.ai" },
  { label: "EnviSafe", href: "https://envisafe.ai", current: true },
  { label: "SafeForm", href: "https://safeform.ai" },
  { label: "WorkSafeStory", href: "https://worksafestory.com" },
  { label: "Pricing", href: PRICING_URL },
  { label: "Services", href: "https://wsafeai.com/services" },
  { label: "Contact", href: CONTACT_URL },
];

export const PRODUCTS = [
  { name: "WSafe AI", icon: `${BRAND}/wsafe-ai/wsafe-ai-32.png`, href: "https://wsafe.ai", desc: "AI hazard detection on existing cameras." },
  { name: "HazardLoop", icon: `${BRAND}/hazardloop/hazardloop-32.png`, href: "https://hazardloop.com", desc: "Corrective action tracking and verified closeout." },
  { name: "InductIQ", icon: `${BRAND}/inductiq/inductiq-32.png`, href: "https://inductiq.ai", desc: "Induction/training verification and incident reporting." },
  { name: "EnviSafe", icon: `${BRAND}/envisafe/envisafe-32.png`, href: "https://envisafe.ai", desc: "Environmental conditions monitoring.", current: true },
  { name: "SafeForm", icon: `${BRAND}/safeform/safeform-32.png`, href: "https://safeform.ai", desc: "Ergonomic analysis." },
  { name: "WorkSafeStory", icon: `${BRAND}/worksafestory/worksafestory-32.png`, href: "https://worksafestory.com", desc: "Safety stories and lessons learned." },
];

export const FOOTER_LINKS = [
  { label: "Pricing", href: PRICING_URL },
  { label: "Compliance Service", href: "https://wsafeai.com/services#compliance" },
  { label: "Consulting", href: "https://wsafeai.com/services#consulting" },
  { label: "Privacy", href: "https://wsafeai.com/privacy" },
  { label: "Terms", href: "https://wsafeai.com/terms" },
  { label: "Contact (info@wsafeai.com)", href: "mailto:info@wsafeai.com" },
];

export const PARTNERS = [
  "Genetec: integration in development",
  "Axis TIPP member",
  "Procore: coming soon",
];

export const PRICING = {
  subsIntro: "Subscriptions, per site per month, plus one-time setup per site:",
  subs: [
    ["Core:", " $1,500/site/month + $5,000 setup. Includes WSafe AI, HazardLoop, WorkSafeStory."],
    ["Pro:", " $3,000/site/month + $10,000 setup. Includes everything in Core plus InductIQ and EnviSafe."],
    ["Vision:", " $6,250/site/month + $25,000 setup. Includes everything in Pro plus SafeForm and continuous CCTV detection."],
    ["Founding paid pilot:", " $1,000, no install fee."],
  ],
  compliance: ["Compliance Evaluation & Documentation Service:", " $1,500 evaluation; then Essentials $500, Standard $1,000 or Premium $2,000 per site/month, billed in addition to a Core or Pro subscription. Covers OSHA and environmental records. Documentation setup is included in the setup fee; work beyond included hours is $150/hr."],
  consulting: ["Consulting:", " $150/hr; $1,500 gap review; $1,500/day audit; $2,500 AI readiness assessment (credited toward a paid pilot); $1,200/month retainer. No travel charge for on-site work within 50 miles of Abilene, Texas."],
};
